import * as React from 'react'
import { TableHeaderColumn } from '@/modules/drivers/types/table'
import TableTextHeader from '@/modules/drivers/shared/tableItems/TableTextHeader'

export const ActivityListHeader = ({
  columns,
}: {
  columns: TableHeaderColumn[]
}) => {
  return (
    <thead
      className={`tw-z-20 notches-border--right tw-sticky tw-top-0  tw-select-none tw-border-b tw-bg-content-primary`}
    >
      <tr>
        {columns.map((col) => (
          <TableTextHeader
            key={col.title}
            fontSize={'sm'}
            bolder={true}
            opacity={true}
            sort={col.sort}
          >
            {col.title}
          </TableTextHeader>
        ))}
      </tr>
    </thead>
  )
}
